// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_WordBreakWhite__FDCJM {
  color: #000;
  font-size: .75rem;
  min-height: 17px;
}

.Profile_Back__2XviV {
  background-color: #0095a3;
  min-height: 155px;
}

.Profile_Back2__NMwNL {
  background-color: #0095a3;
}

.Profile_Icon__hAGQb i {
  color: #fff;
}

.Profile_CardHead__0MVQ5 {
cursor: pointer;
}

.Profile_CardHead__0MVQ5:hover {
  background-color: #22b9c1;
}

.Profile_WhiteName__F2vcv {
  color: #fff;
  font-style: italic;
}

.Profile_WhiteT__Sljxf {
  color: #fff;
  min-height: 50px;
  font-style: italic;
}

.Profile_Small__uaWPS {
  font-size: .75rem;
}

.Profile_BoldScene__ObrQC {
  color: rgba(129, 102, 21, 0.99);
  font-weight: 600;
}

.Profile_Input__vjBLV {
  background: #ffffff;
  border: 1px solid #e0e3eb;
  box-sizing: border-box;
  border-radius: 2px;
  color: #747686;
  padding: 0px 10px;
  height: 30px !important;
  text-align: center;
  color: rgba(84, 64, 6, 0.99);
  color: #3d3d3e;
}

.Profile_InputScene__aTh0Q {
 background: #ffffff;
 border: 1px solid #e0e3eb;
 box-sizing: border-box;
 border-radius: 2px;
 color: #747686;
 padding: 0px 10px;
 text-align: center;
 min-height: 30px !important;
 color: #3d3d3e;
}

.Profile_ImagesIndex__R3Fa0 {
    object-fit: cover; 
    /* height: 150px;
    width: 100%; */
    height: 60px;
    width: 60px;
    border-radius: 50%;
}

.Profile_White__NVbjR {
  background-color: #fff;
}

.Profile_SubTitle__6CWER {
  background-color: #e8f0f1;
  font-weight: 700;
}

.Profile_Posit__1-ra2 {
  color: #000;
}

.Profile_Small__uaWPS {
  font-size: .8rem;
}

.Profile_BreakTitle__rjpVe {
  border-top: 10px solid #e8f0f1;
}

.Profile_Content__yo3cd {
  font-style: italic;
}

.Profile_Likes__Y8h3A {
  color: #fff;
  font-size: .7rem;
}
.Profile_Follow__wZKW- {
  background-color: #58666b;
  color: #fff;
  font-weight: 700;
}

a:hover {
  color:aqua
}

/* profilepage */

.Profile_ProfileImage__juAkn {
  object-fit: cover;
  height: 80px;
  width: 80px;
  margin: 4px;
}

@media screen and (max-width: 991px) {
  .Profile_ProfileImage__juAkn {
    width: 50px;
    height: 50px;
  }
}

@media screen and (max-width: 600px) {
.Profile_WordBreakWhite__FDCJM {
  min-height: 10px;
  font-size: .65rem;
}
.Profile_Input__vjBLV {
  height: 20px !important;
  text-align: center;
  font-size: .75rem !important;
}

.Profile_InputScene__aTh0Q {
  font-size: .75rem !important;
 }

.Profile_BoldScene__ObrQC {
  font-size: .75rem !important;
}

p {
    font-size: .75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Profile.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;AACA,eAAe;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,2BAA2B;CAC3B,cAAc;AACf;;AAEA;IACI,iBAAiB;IACjB;kBACc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA,gBAAgB;;AAEhB;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;CAC7B;;AAED;EACE,4BAA4B;AAC9B;;AAEA;IACI,iBAAiB;EACnB;AACF","sourcesContent":[".WordBreakWhite {\n  color: #000;\n  font-size: .75rem;\n  min-height: 17px;\n}\n\n.Back {\n  background-color: #0095a3;\n  min-height: 155px;\n}\n\n.Back2 {\n  background-color: #0095a3;\n}\n\n.Icon i {\n  color: #fff;\n}\n\n.CardHead {\ncursor: pointer;\n}\n\n.CardHead:hover {\n  background-color: #22b9c1;\n}\n\n.WhiteName {\n  color: #fff;\n  font-style: italic;\n}\n\n.WhiteT {\n  color: #fff;\n  min-height: 50px;\n  font-style: italic;\n}\n\n.Small {\n  font-size: .75rem;\n}\n\n.BoldScene {\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 600;\n}\n\n.Input {\n  background: #ffffff;\n  border: 1px solid #e0e3eb;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #747686;\n  padding: 0px 10px;\n  height: 30px !important;\n  text-align: center;\n  color: rgba(84, 64, 6, 0.99);\n  color: #3d3d3e;\n}\n\n.InputScene {\n background: #ffffff;\n border: 1px solid #e0e3eb;\n box-sizing: border-box;\n border-radius: 2px;\n color: #747686;\n padding: 0px 10px;\n text-align: center;\n min-height: 30px !important;\n color: #3d3d3e;\n}\n\n.ImagesIndex {\n    object-fit: cover; \n    /* height: 150px;\n    width: 100%; */\n    height: 60px;\n    width: 60px;\n    border-radius: 50%;\n}\n\n.White {\n  background-color: #fff;\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n  font-weight: 700;\n}\n\n.Posit {\n  color: #000;\n}\n\n.Small {\n  font-size: .8rem;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.Content {\n  font-style: italic;\n}\n\n.Likes {\n  color: #fff;\n  font-size: .7rem;\n}\n.Follow {\n  background-color: #58666b;\n  color: #fff;\n  font-weight: 700;\n}\n\na:hover {\n  color:aqua\n}\n\n/* profilepage */\n\n.ProfileImage {\n  object-fit: cover;\n  height: 80px;\n  width: 80px;\n  margin: 4px;\n}\n\n@media screen and (max-width: 991px) {\n  .ProfileImage {\n    width: 50px;\n    height: 50px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n.WordBreakWhite {\n  min-height: 10px;\n  font-size: .65rem;\n}\n.Input {\n  height: 20px !important;\n  text-align: center;\n  font-size: .75rem !important;\n}\n\n.InputScene {\n  font-size: .75rem !important;\n }\n\n.BoldScene {\n  font-size: .75rem !important;\n}\n\np {\n    font-size: .75rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"WordBreakWhite": `Profile_WordBreakWhite__FDCJM`,
	"Back": `Profile_Back__2XviV`,
	"Back2": `Profile_Back2__NMwNL`,
	"Icon": `Profile_Icon__hAGQb`,
	"CardHead": `Profile_CardHead__0MVQ5`,
	"WhiteName": `Profile_WhiteName__F2vcv`,
	"WhiteT": `Profile_WhiteT__Sljxf`,
	"Small": `Profile_Small__uaWPS`,
	"BoldScene": `Profile_BoldScene__ObrQC`,
	"Input": `Profile_Input__vjBLV`,
	"InputScene": `Profile_InputScene__aTh0Q`,
	"ImagesIndex": `Profile_ImagesIndex__R3Fa0`,
	"White": `Profile_White__NVbjR`,
	"SubTitle": `Profile_SubTitle__6CWER`,
	"Posit": `Profile_Posit__1-ra2`,
	"BreakTitle": `Profile_BreakTitle__rjpVe`,
	"Content": `Profile_Content__yo3cd`,
	"Likes": `Profile_Likes__Y8h3A`,
	"Follow": `Profile_Follow__wZKW-`,
	"ProfileImage": `Profile_ProfileImage__juAkn`
};
export default ___CSS_LOADER_EXPORT___;
